import { CURRENT_WEEK, CURRENT_YEAR } from 'common/helpers/date.helper';
import { IMonitorSalesProductItem } from 'entities/MonitorSales/MonitorSales.models';

export const formatValue = (label: string, value: number, maximumFractionDigits?: number): string => {
  if (label === 'TC') {
    return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  return `₱ ${value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};

export const getMonitorSalesFilterWeek = (year?: number, week?: number): string | undefined => {
  if (week === undefined) {
    return undefined;
  }

  const effectiveYear = year ?? CURRENT_YEAR;

  if (effectiveYear === CURRENT_YEAR && week === CURRENT_WEEK) {
    return 'last7days';
  }

  if (effectiveYear === CURRENT_YEAR && week === CURRENT_WEEK - 1) {
    return 'lastWeek';
  }

  return `${effectiveYear}-W${String(week).padStart(2, '0')}`;
};

export const sortProductSalesBySalesPercentDesc = (products: IMonitorSalesProductItem[]): IMonitorSalesProductItem[] =>
  [...products].sort((a, b) => b.salesPercent - a.salesPercent);
